export default [...Array(15)].map((_, i) => `${`${i+5}`.padStart(2, '0')}:00`); // Array(15) intervalo de 15 horas
